import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon }) => {
  const navigate = useNavigate();

  return (
    <div className="page-header">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="page-header-back"
      >
        <span>العودة</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M6 4L10 8L6 12" stroke="#6B7280" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <div className="page-header-titles">
        <div className="page-header-title-row">
          <h1 className="page-header-title">{title}</h1>
          <div className="page-header-icon" aria-hidden="true">
            {icon}
          </div>
        </div>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PageHeader;
